<div fxLayout="row" fxLayoutGap="8px" class="snack-container">
    <mat-icon class="icon">{{icon}}</mat-icon>
    <span fxFlex="grow">{{data.message}}</span>
    <button *ngIf="data.buttonText" mat-icon-button (click)="snackBarRef.dismiss()">{{data.buttonText}}</button>
</div>